export default {
    props: ['datas'],
    data() {
        return {
            inputColumns: [
                {
                    title: '字段',
                    key: 'columnName',
                    align: 'center',
                    tooltip: true,
                    ellipsis: true,
                },
                {
                    title: '别名',
                    key: 'commentText',
                    align: 'center',
                    tooltip: true,
                    ellipsis: true,
                },
                {
                    title: '类型',
                    key: 'columnType',
                    align: 'center',
                    tooltip: true,
                    ellipsis: true,
                }
            ],
            inputTablesList: [],
            outColumns: [
                {
                    title: '字段',
                    key: 'columnName',
                    align: 'center',
                    tooltip: true,
                    ellipsis: true,
                },
                {
                    title: '别名',
                    key: 'commentText',
                    align: 'center',
                    tooltip: true,
                    ellipsis: true,
                },
                {
                    title: '类型',
                    key: 'columnType',
                    align: 'center',
                    tooltip: true,
                    ellipsis: true,
                }
            ],
            outTablesList: []
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.datas.outOrinFields) {
                let data = JSON.parse(this.datas.outOrinFields);
                for (let i = 0; i < data.length; i++) {
                    if (data[i].inputisselected == true) { //输入字段列表
                        this.inputTablesList.push(data[i])
                    }
                    if (data[i].outputisselected == true) { //输出字段列表
                        this.outTablesList.push(data[i])
                    }
                }
            }

        },
    },
}


// WEBPACK FOOTER //
// ./src/components/leftmenu/layers/showDatial/showdetail.js